<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      textDemo: true
    }
  },
  components: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style>
  @import './style/reset.css';
  @import './style/font/fontStyle.css';
  @import './style/public.css';
  .mint-tabbar{
    position: fixed;
  }
  .mint-tab-item.is-selected{
    background: #fff !important;
    color: #078fea !important;
  }
</style>
